import { render, staticRenderFns } from "./bidStage.vue?vue&type=template&id=206b4bd5&scoped=true&"
import script from "./bidStage.vue?vue&type=script&lang=js&"
export * from "./bidStage.vue?vue&type=script&lang=js&"
import style0 from "./bidStage.vue?vue&type=style&index=0&id=206b4bd5&scoped=true&lang=css&"
import style1 from "./bidStage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b4bd5",
  null
  
)

export default component.exports